import { render, staticRenderFns } from "./Box.vue?vue&type=template&id=77df00ac"
import script from "./Box.vue?vue&type=script&lang=js"
export * from "./Box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77df00ac')) {
      api.createRecord('77df00ac', component.options)
    } else {
      api.reload('77df00ac', component.options)
    }
    module.hot.accept("./Box.vue?vue&type=template&id=77df00ac", function () {
      api.rerender('77df00ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/reports/charts/Box.vue"
export default component.exports